import { X4bActivityStatus } from "@/services/signalr.service";
import { ActivityHelper, X4bActivityDto } from "../../vehicle/engine/X4bActivityDto";
import { XpressVehicleType } from "../../vehicle/engine/VehicleType";
import moment from "moment";
import { X4bEmployeeStatus } from "@/types";
import { BookingType, DeliveryItemType, DeliverySize, PassengerDto, X4bVehicleColor } from "@/modules/vehicle/engine/ActivityTypes";
import { ReturnSendBookingType } from "../new-send-booking/formTypes";
import _ from "lodash";
import ConciergeCard, { CardInfoType } from "../cards/ConciergeCard";
import { ConciergeAwaitingCard, ConciergeCompletedCard, ConciergeRequestingCard, ConciergeScheduledCard } from "../cards/ConciergeCards";
import { NewRideType, ReturnTripType } from "../new-ride/ConciergeNewRide";
import { X4bLocation } from "../views/PlacesRepository";
import FlagsModel, { Flag } from "@/modules/authentication/sign-up/components/CountryFlags";
import { PhoneHelper } from "@/common/PhoneHelper";

export type PassengerInfo = {
	name: string;
	phone: string;
}

export enum TripType {
	RoundTrip,
	OneWay,
}
export enum ActivityBlockGroupBy {
	Status,
	Date
}
// Section stands for section in the left menu. Label stands for the label on the right. Dispite that they are very similar it is better to keep them separate to avoid mess.
export enum X4bActivitySection {
	TodaysActivity,
	NeedsAttention,
	Requesting,
	AwaitingPickup,
	InProgress,
	Completed,
	Canceled,
	Scheduled,
	PastActivity,
}

export type TripPoint = {
	name: string;
	address: string;
}



export type TripVehicle = {
	type: XpressVehicleType;
	vehicleColor?: X4bVehicleColor;
	plate: string;
	name: string;
	vehicle: string;
}

export enum TripDriverState {
	None = 1,
	DriverCancelled,
	FindingDriver,
}
/* Semantically more correct name for that would be ConciergeCardViewModel.
For later:
To have ubiquitous vocabulary here and avoid ambiguity we need to eliminate "Trip".
Update: the TripData is mostly excessive and was born because we had no backend initially. We need to use activity data whenever possible. And avoid excessive mapping and complexity.
*/
export type TripData = {
	id: number;
	act: X4bActivityDto;
	xpressId?: string;
	type: TripType;
	date?: Date;
	pickup: TripPoint;
	destination: TripPoint;
	passenger: PassengerInfo;
	additionalPassengers: PassengerInfo[];
	activitySection: X4bActivitySection;
	duration?: number;
	cost?: number;
	infernalMemo?: string;
	noteToDriver?: string;
	progress: number;
	statusText: string;
	extraText: string;
	extraTextColor: string;
	tripDriverState: TripDriverState;
	driverName: string;
	driverRating: number;
	vehicle: TripVehicle;
	needsAttentionIsRebookRide: boolean;
	needsAttentionIsContactSupport: boolean;
}
// // let's keep the mapping of statuses here for a while, this is currently dark part in requirements. So, we take statuses from Xpress as is and adapt to current figma design.
// export const convertStatus = (status: X4bActivityStatus): X4bActivityLabel => {

// 	switch (status) {
// 		case X4bActivityStatus.RepeatScheduled:
// 			return X4bActivityLabel.Scheduled;
// 		case X4bActivityStatus.New:
// 		case X4bActivityStatus.RiderAssigning:
// 			return X4bActivityLabel.Requesting;
// 		case X4bActivityStatus.RiderAssigned:
// 		case X4bActivityStatus.RiderAccept:
// 		case X4bActivityStatus.RiderAcceptB2B:
// 		case X4bActivityStatus.ArrivedToPickup:
// 			return X4bActivityLabel.AwaitingPickup;
// 		case X4bActivityStatus.DepartedToPickup:
// 		case X4bActivityStatus.PickedUp:
// 		case X4bActivityStatus.ArrivedToDrop:
// 			return X4bActivityLabel.InProgress;
// 		case X4bActivityStatus.Completed:
// 			return X4bActivityLabel.Completed;
// 		case X4bActivityStatus.Canceled:
// 		case X4bActivityStatus.Rejected:
// 		case X4bActivityStatus.Expired:
// 			return X4bActivityLabel.Cancelled;
// 		default:
// 			return X4bActivityLabel.TodaysActivity;
// 	}
// }
// Label statuses loses lots of info comparint to activity status. Prefer to use activity status.
function getStatusText(act: X4bActivityDto, status?: X4bActivityStatus): string {
	// TODO[Pahse2]: mockup for needs attension have no sense currently. Needs attention label still needs to vary behaviour depending on activity statuses.
	//  if (status === X4bActivityLabel.NeedsAttention) {
	// 	const t1 = act.TimeTillDropOffInSeconds ? moment().add(act.TimeTillDropOffInSeconds, 'seconds') : null;
	// 	return `Drop off at ${t1?.format('hh:mmA z') ?? '...'}`;
	// } else
	if (status === X4bActivityStatus.RiderAssigned || status === X4bActivityStatus.DepartedToPickup) {
		return `Pickup in ${_.isNumber(act.TimeTillPickUpInSeconds) ? Math.ceil(act.TimeTillPickUpInSeconds / 60) : '...'}
		minutes`;
	}
	// Theoretically this case wouldn have 0 minutes, but in fact it doesn't. So, lets set 0 based on status.
	else if (status === X4bActivityStatus.ArrivedToPickup) {
		return `Pickup in 0 minutes`;
	}
	else if (status === X4bActivityStatus.PickedUp) {
		const t1 = _.isNumber(act.TimeTillDropOffInSeconds) ? moment().add(act.TimeTillDropOffInSeconds, 'seconds') : null;
		return `Drop off at ${t1?.format('hh:mmA z') ?? '...'}`;
	}
	else return '';
}
function getExtraText(act: X4bActivityDto, label: X4bActivitySection): string {
	if (ActivityHelper.isCompleted(act)) {
		if (label === X4bActivitySection.PastActivity) {
			return 'Completed Ride';
		} else {
			return `Dropped off at ${act.CompletedTime ? moment.utc(act.CompletedTime).local().format('hh:mmA') : '...'}`;
		}
	}
	else if (ActivityHelper.isCanceled(act)) {
		return 'Cancelled Ride';
	} else if (ActivityHelper.isScheduled(act)) {
		return act.Date
			? moment(act.Date).format('h:mm A')
			: '';
	} else
		return '';
}
function getExtraTextColor(act: X4bActivityDto): string {
	if (ActivityHelper.isInProgress(act) || ActivityHelper.isCanceled(act)) {
		return 'text-error60';
	} else return '';
}

function getDriverState(act: X4bActivityDto): TripDriverState {
	/*Even after rename of the function the code was absolute nonsense. I understand that it may be behaved as on mockups, but the code should make sense.
	 if (status === X4bActivityLabel.NeedsAttention) {
			return TripExtraType.DriverCancelled;
	 }
	 else if (status === X4bActivityLabel.Scheduled) {
			return TripExtraType.FindingDriver;
	 }*/
	return TripDriverState.None;
}
function getPassengerFullName(p: PassengerDto) {
	return `${p?.FirstName} ${p?.LastName}`;
}


// Card component should differentiate based on activity data, not based on derivative view model stuff like label. For example completed card can be in 3 labels: today, completed, past. But renders the same. Also, label is just view attribute, please, don't connect tons of logic to it.
export function getActivityCardComponent(trip: TripData): React.ComponentType<any> {
	const a = trip.act;
	const status = a.Status;
	if (status === undefined) return ConciergeCard;

	if (ActivityHelper.isScheduled(a))
		return ConciergeScheduledCard;
	else if (ActivityHelper.isRequesting(a))
		return ConciergeRequestingCard;
	else if (ActivityHelper.isAwaitingPickup(a))
		return ConciergeAwaitingCard;
	else if (ActivityHelper.isInProgress(a))
		return ConciergeCard;
	else if (ActivityHelper.isCompleted(a))
		return ConciergeCompletedCard;
	else if (ActivityHelper.isCanceled(a))
		return ConciergeCard;

	else return ConciergeCard;

}

export function getActivityCardInfoType(tripInfo: TripData) {
	const status = tripInfo.act.Status;
	if (status === undefined) throw Error('ConciergeCard infoType is undefined');

	// TODO: requirements for Needs Attention are not known yet, so, its is fine to comment out for now
	//  if (tripInfo.activityLabel === X4bActivityLabel.NeedsAttention) {
	// 	if (tripInfo.needsAttentionIsRebookRide) infoType = CardInfoType.TripInfo;
	// 	else if (tripInfo.needsAttentionIsContactSupport) infoType = CardInfoType.VehicleInfo;
	// }
	if ([X4bActivityStatus.New, X4bActivityStatus.RiderAssigning].includes(status))
		return CardInfoType.PickupDestination;
	else if ([X4bActivityStatus.RiderAssigned, X4bActivityStatus.RiderAccept, X4bActivityStatus.RiderAcceptB2B, X4bActivityStatus.ArrivedToPickup].includes(status))
		return CardInfoType.VehicleInfo;
	else if ([X4bActivityStatus.DepartedToPickup, X4bActivityStatus.PickedUp, X4bActivityStatus.ArrivedToDrop].includes(status))
		return CardInfoType.VehicleInfo;
	else if ([X4bActivityStatus.Completed].includes(status))
		return CardInfoType.VehicleTripInfo;
	else if ([X4bActivityStatus.Canceled, X4bActivityStatus.Rejected, X4bActivityStatus.Expired].includes(status))
		return CardInfoType.TripInfo;
	else if ([X4bActivityStatus.RepeatScheduled].includes(status)) {
		let infoType = CardInfoType.VehicleTripInfo;
		if (ActivityHelper.isDriverAssigned(tripInfo.act)) infoType = CardInfoType.VehicleTripInfo;
		else if (tripInfo.tripDriverState === TripDriverState.FindingDriver) infoType = CardInfoType.TripInfo;
		return infoType;
	} else throw Error('ConciergeCard infoType is undefined');

}

/**
 * Maps activity data to NewRideType format for creating a return trip.
 * Swaps pickup and dropoff locations to create the reverse journey.
 * Also extracts country code from phone number and returns it separately.
 * Includes additional passengers from the original trip.
 */
export function mapActivityToReturnTrip(act: X4bActivityDto): ReturnTripType {
	const fullPhone = act.HeadPassenger?.Phone || '';
	const countryFlag = FlagsModel.flagByPhone(fullPhone);
	const phoneWithoutDialCode = FlagsModel.removeDialCode(fullPhone);

	// Map additional passengers, removing dial codes from their phone numbers
	const additionalPassengers: PassengerDto[] = (act.AdditionalPassengers || []).map(passenger => ({
		FirstName: passenger.FirstName,
		LastName: passenger.LastName,
		/* The phone is already with country code here.
		Note: to have fun you may try to remove it here and re-add on the ConciergeNewRide screen.
		*/
		Phone: passenger.Phone,
		//Country: passenger.Phone ? FlagsModel.flagByPhone(passenger.Phone) : undefined,
	}));

	// Store date as ISO string to avoid serialization issues with Moment objects
	// Moment objects contain functions and can't be cloned by browser history API
	const dateValue = act.Date ? moment(act.Date).toISOString() : undefined;


	return {
		initialData: {
			firstName: act.HeadPassenger?.FirstName || '',
			lastName: act.HeadPassenger?.LastName || '',
			phone: phoneWithoutDialCode,
			// Swap pickup and dropoff for return trip
			pickUpAddress: act.Dropoff as X4bLocation,
			dropOffAddress: act.Pickup as X4bLocation,
			bookingType: act.BookingType,
			// Store date as ISO string for serialization, will be converted back to Moment when loaded
			date: dateValue as any,
			timeInSeconds: act.TimeInSec,
			internalMemo: act.Memo,
			noteToDriver: act.Note,
		},
		countryFlag,
		additionalPassengers: additionalPassengers.length > 0 ? additionalPassengers : undefined,
		vehicleType: act.VehicleType
	};
}

/**
 * Maps a completed delivery/send activity to the NewSendBooking prefill format for a return trip.
 * Swaps sender <-> recipient and pickup <-> dropoff to reverse the journey, and carries over the
 * parcel details. Phone numbers are split into a country code and a national number, mirroring the
 * way the ride return trip handles them. The parcel photo cannot be carried over and must be re-added.
 */
export function mapActivityToReturnSendBooking(act: X4bActivityDto): ReturnSendBookingType {
	const d = act.DeliveryOptions;

	// New sender is the previous recipient; new recipient is the previous sender.
	const newSenderPhoneFull = d?.DeliveryRecipientPhone || '';
	const newSenderFlag = FlagsModel.flagByPhone(newSenderPhoneFull);

	const newRecipientPhoneFull = d?.DeliverySenderPhone || '';
	const newRecipientFlag = FlagsModel.flagByPhone(newRecipientPhoneFull);

	return {
		senderContactName: d?.DeliveryRecipientName || '',
		senderPhone: FlagsModel.removeDialCode(newSenderPhoneFull),
		senderMobileNumberPrefix: newSenderFlag?.code || 'PH',
		// Swap pickup and dropoff for the return trip.
		pickUpAddress: act.Dropoff as X4bLocation | undefined,
		recipientContactName: d?.DeliverySenderName || '',
		recipientPhone: FlagsModel.removeDialCode(newRecipientPhoneFull),
		recipientMobileNumberPrefix: newRecipientFlag?.code || 'PH',
		dropOffAddress: act.Pickup as X4bLocation | undefined,
		deliveryItemType: d?.DeliveryItemTypeId ?? DeliveryItemType.None,
		parcelSize: d?.DeliverySize ?? DeliverySize.None,
		weightMaxKg: d?.DeliveryWeight ?? undefined,
		driverNotes: act.Note || '',
		vehicleType: act.VehicleType,
	};
}

export function mapActivitiesToViewModels(activities: X4bActivityDto[]): TripData[] {

	const durationSamples = [136, 81, 8];
	//const costSamples = [832, 62, 9];
	//const progressSamples = [100, 47, 10];

	return activities.map((act, ind) => {
		const i = ind % 3;
		// Let's use needs attention for missing labels, seems sensible.
		const activitySection = act.ActivitySection ?? X4bActivitySection.NeedsAttention// X4bActivityLabel = convertStatus(act.Status ?? X4bActivityStatus.New);
		let progress = 0;
		if (act.Status == X4bActivityStatus.RiderAssigned || act.Status == X4bActivityStatus.DepartedToPickup) {
			if (act.RiderAssignedTime && (_.isNumber(act.TimeTillPickUpInSeconds))) {
				const passedSeconds = moment().diff(moment.utc(act.RiderAssignedTime), 'seconds');
				progress = 100 * passedSeconds / (passedSeconds + act.TimeTillPickUpInSeconds);
			}

		} else if (act.Status == X4bActivityStatus.ArrivedToPickup) {
			progress = 100;
		} else if (act.Status == X4bActivityStatus.PickedUp) {
			if (act.PickedUpTime && (act.TimeTillDropOffInSeconds || act.TimeTillDropOffInSeconds === 0)) {
				const passedSeconds = moment().diff(moment.utc(act.PickedUpTime), 'seconds');
				progress = 100 * passedSeconds / (passedSeconds + act.TimeTillDropOffInSeconds);
			}
		}

		return {
			id: act.Id,
			act: act,
			type: TripType.OneWay,//TODO
			xpressId: act.XpressId,
			date: act.Date,
			pickup: { name: act.Pickup?.Name ?? act.Pickup?.PlaceName ?? "", address: act.Pickup?.Address ?? "" },
			destination: { name: act.Dropoff?.Name ?? act.Dropoff?.PlaceName ?? "", address: act.Dropoff?.Address ?? "" },
			passenger: { name: getPassengerFullName(act.HeadPassenger), phone: act.HeadPassenger.Phone ?? '' },
			additionalPassengers: act.AdditionalPassengers.map(p => {
				return { name: getPassengerFullName(p), phone: p.Phone ?? '' }
			}),
			activitySection: activitySection,
			duration: durationSamples[i],//TODO
			cost: act.Amount,
			infernalMemo: act.Memo,
			noteToDriver: act.Note,
			progress: progress,
			statusText: getStatusText(act, act.Status),
			extraText: getExtraText(act, activitySection),
			extraTextColor: getExtraTextColor(act),
			tripDriverState: getDriverState(act),
			driverName: act.Driver?.Name,
			driverRating: act.Driver?.Rating,
			needsAttentionIsRebookRide: false,//i % 2 === 0 ? true : false,//TODO
			needsAttentionIsContactSupport: false,//i % 2 !== 0 ? true : false,//TODO
			vehicle: {
				name: act.Driver?.Name,
				plate: act.Driver?.Plate,
				vehicle: act.Driver?.Vehicle,
				phone: act.Driver?.Phone,
				rating: act.Driver?.Rating,
				vehicleColor: act.Driver?.VehicleColor,
				type: act.VehicleType
			} as TripVehicle,
		} as TripData
	}
	);
}
